import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=f0a84c52&scoped=true&"
import script from "./PatientList.vue?vue&type=script&lang=js&"
export * from "./PatientList.vue?vue&type=script&lang=js&"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=f0a84c52&lang=scss&scoped=true&"
import style1 from "./PatientList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a84c52",
  null
  
)

export default component.exports